// extracted by mini-css-extract-plugin
module.exports = {"template":"BodySubSecurityTemplate_template_1Mf31","desktop":"BodySubSecurityTemplate_desktop_16BVd","mobile":"BodySubSecurityTemplate_mobile_L2CRE"};